import { render, staticRenderFns } from "./layoutMain.vue?vue&type=template&id=6663bbf8&scoped=true&"
import script from "./layoutMain.vue?vue&type=script&lang=js&"
export * from "./layoutMain.vue?vue&type=script&lang=js&"
import style0 from "./layoutMain.vue?vue&type=style&index=0&id=6663bbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6663bbf8",
  null
  
)

export default component.exports